// extracted by mini-css-extract-plugin
export default {"root":"_1G2An","variant-horizontal":"_3m5KZ","variantHorizontal":"_3m5KZ","title":"_3T7Zd","message":"_10a09","core-star":"_369gL","coreStar":"_369gL"};